import { Component, Output, EventEmitter } from '@angular/core';
import { StageService } from '../services/stage.service';
import { SceneUtilsService } from '../services/scene-utils.service';
declare let THREE: any;
import { ComponentBase } from '../component-base';
import { BuildTierService } from '../services/build-tier.service';
import { RemoveTierService } from '../services/remove-tier.service';
import { TierStepWidthService } from '../services/tier-step-width.service';
import { Select3dService } from '../services/select-3d.service';
import { DragFloorEdge } from '../services/drag-floor-edge.service';
import { DataForDisplayingMenuItemsService } from '../services/data-for-displaying-menu-items.service';

@Component({
  selector: 'app-add-tiers',
  templateUrl: './add-tiers.component.html',
  styleUrls: ['./add-tiers.component.scss']
})

export class AddTiersComponent extends ComponentBase {

  private raycaster: any = new THREE.Raycaster();
  selectedTierType = '';

  @Output() step1Editer = new EventEmitter();

  goBack(value) {
    this.step1Editer.emit({ name: value });
    this.dataForDisplayingMenuItemsService.changeSelectedMenuItem.next('');
  }

  constructor(
    private buildTierService: BuildTierService,
    private removeTierService: RemoveTierService,
    private sceneUtils: SceneUtilsService,
    private stage: StageService,
    private tierStepWidthService: TierStepWidthService,
    private select3dService: Select3dService,
    private dragFloorEdge: DragFloorEdge,
    private dataForDisplayingMenuItemsService: DataForDisplayingMenuItemsService
  ) {
    super();
    this.select3dService.selectedTierSubject.subscribe(selectedTier => {
      if (this.isEnabled() && !selectedTier) {
        this.remove();
      }
    });
    this.dataForDisplayingMenuItemsService.changeSelectedMenuItem.subscribe(value => {
      this.selectedTierType = value;
    })
  }

  mouseDown(e) {
    var p = this.sceneUtils.getRay(e.offsetX, e.offsetY);
    this.raycaster.ray.origin.copy(p.ray.origin);
    this.raycaster.ray.direction.copy(p.ray.direction);

    var floor = this.stage.getCompoundFloor();
    let sprites = this.stage.getSprites();
    var intersection = this.raycaster.intersectObjects([...floor.children, ...sprites]);
    if (!intersection.length) {
      this.dataForDisplayingMenuItemsService.changeSelectedMenuItem.next('');
      this.remove();
    }
  }

  drawSprites(tierType) {
    // this.tierStepWidthService.disable();
    if (!this.buildTierService.isEnabled() || this.buildTierService.tierType !== tierType) {
      this.remove();
      this.buildTierService.enable();
      this.buildTierService.drawSprites(tierType);
      this.dragFloorEdge.disable();
      this.dataForDisplayingMenuItemsService.changeSelectedMenuItem.next(tierType);
    } else {
      this.dataForDisplayingMenuItemsService.changeSelectedMenuItem.next('');
      this.buildTierService.disable();
      this.dragFloorEdge.enable();
    }
    this.tierStepWidthService.enable();
  }

  removeTier() {
    if (!this.removeTierService.isEnabled()) {
      this.remove();
      this.removeTierService.enable();
      this.removeTierService.drawSprites();
      this.dataForDisplayingMenuItemsService.changeSelectedMenuItem.next('remove')
    } else {
      this.dataForDisplayingMenuItemsService.changeSelectedMenuItem.next('')
      this.removeTierService.removeSprites();
      this.removeTierService.disable();
    }
  }

  remove() {
    this.buildTierService.disable();
    this.removeTierService.removeSprites();
    this.removeTierService.disable();
    this.tierStepWidthService.removeSprites();
    this.dragFloorEdge.enable(); 
  }
}



// WEBPACK FOOTER //
// ./src/app/add-tiers/add-tiers.component.ts